'use strict';

export default function routes($stateProvider) {
  'ngInject';

  $stateProvider.state('oem_main.demand_control_index', {
    url: '/company/:company_id/demand_control_index?target&value',
    template: '<oem-demand-control-index></oem-demand-control-index>'
  });
};



// WEBPACK FOOTER //
// ./public/dev/app/oem/demand_control/index/demand_control_index.routes.js